import React from 'react';
import PropTypes from 'prop-types';
import { dates } from '@unite-us/client-utils';
import { isNumber } from 'lodash';
var SocialInsuranceDate = function SocialInsuranceDate(_ref) {
  var value = _ref.value,
    label = _ref.label,
    message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uppercase text-dark-blue text-xs font-heavy-font tracking-wider"
  }, label), /*#__PURE__*/React.createElement("div", null, value ? dates.formatDate(value) : message));
};
SocialInsuranceDate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired
};
SocialInsuranceDate.defaultProps = {
  value: undefined
};
export var SocialInsuranceStartDate = function SocialInsuranceStartDate(_ref2) {
  var value = _ref2.value;
  return /*#__PURE__*/React.createElement(SocialInsuranceDate, {
    value: value,
    label: "Start Date",
    message: "Social care coverage will start once the client is enrolled."
  });
};
SocialInsuranceStartDate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
SocialInsuranceStartDate.defaultProps = {
  value: undefined
};
export var SocialInsuranceEndDate = function SocialInsuranceEndDate(_ref3) {
  var value = _ref3.value,
    coveragePeriod = _ref3.coveragePeriod;
  return /*#__PURE__*/React.createElement(SocialInsuranceDate, {
    value: value,
    label: "End Date",
    message: isNumber(coveragePeriod) ? "Social care coverage will end ".concat(coveragePeriod, " days after the start date.") : 'Social care coverage will end when the client is disenrolled.'
  });
};
SocialInsuranceEndDate.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  coveragePeriod: PropTypes.number
};
SocialInsuranceEndDate.defaultProps = {
  value: undefined,
  coveragePeriod: null
};
//# sourceMappingURL=SocialInsuranceDates.js.map